import { MenuRight, MyFirmListItem } from "@/lib/types";
import { exists, t } from "i18next";

export const getFilteredMenuItemsByFirm = (menuItems: MenuRight[], activeFirm?: MyFirmListItem) => {
  const filteredMenuItems = menuItems
    .slice()
    .sort((a, b) => a.order - b.order)
    .filter((item) => {
      // Eğer bir firma seçili değilse veya seçili firma guid'i null ise
      if (!activeFirm || activeFirm.firmGuid == null) {
        // adminOnly true olanları göster
        if (item.adminOnly) {
          return true;
        }
      } else {
        // Eğer firma seçili ise ve adminOnly false olanları göster
        if (!item.adminOnly) {
          return true;
        }
      }
      return false;
    });

  return filteredMenuItems;
};

export const tryGetTranslatedMenuName = (menuName?: string) => {
  if (!menuName) {
    return "";
  }
  if (exists(`entities.${menuName}`)) {
    return t(`entities.${menuName}`);
  }
  if (exists(`entities.${menuName.toLowerCase()}`)) {
    return t(`entities.${menuName.toLowerCase()}`);
  }
  if (exists(menuName)) {
    const translatedMenuName = t(menuName);
    if (typeof translatedMenuName === "string") {
      return translatedMenuName;
    }
    return menuName;
  }

  return menuName;
};
